import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map, shareReplay, tap} from 'rxjs/operators';
import {FlimmoMetaService} from '../../../../core/services/flimmo-meta.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BesprechungStoreService} from '../../stores/besprechung-store.service';
import {SubSink} from 'subsink';
import {BesprechungPageService} from '../../services/besprechung-page.service';
import {Besprechung} from '../../../../generated-api';

@Component({
    selector: 'app-besprechung-page',
    templateUrl: './besprechung-page.component.html',
    styleUrls: ['./besprechung-page.component.scss'],
    standalone: false,

})
export class BesprechungPageComponent implements OnInit {
  id;
  title;


  subs = new SubSink();
  selectedBesprechung$ = this.detailsStore.besprechung$.pipe(tap(x => {
    this.selectedBesprechung = x;
  }));
  selectedBesprechung = null;

  constructor(private flimmoMetaService: FlimmoMetaService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private besprechungPageService: BesprechungPageService,
              private route: ActivatedRoute, public detailsStore: BesprechungStoreService,
              private breakpointObserver: BreakpointObserver) {
  }

  ngOnInit(): void {
    this.subs.sink = this.activatedRoute.paramMap.subscribe(value => {
        const id = value.get('id');
        const title = value.get('title');
        this.flimmoMetaService.setFlimmoTitle('FLIMMO Besprechung');

        if ((id && !title) || this.selectedBesprechung === null || this.selectedBesprechung.id !== id) {
          if (id === '0') {
            this.detailsStore.besprechung = null;
          }
          this.besprechungPageService.getBesprechung(id, (data: Besprechung) => {
            // rating: "1: Rot, 2: Gelb, 3: Grün, 4: Grün + Prädikat"
            //     'ratingValue': (this.details.rating.id == 4) ? 'FLIMMO findet\'s gut! (ab '+ this.details.altersfreigabe +')' : (this.details.rating.id == 3) ? 'Grün (ab '+ this.details.altersfreigabe +')' : (this.details.rating.id == 2) ? 'Gelb (aus pädagogischer Sicht problematisch)' : 'Rot (nicht für Kinder geeignet)',
            this.flimmoMetaService.setFlimmoTitle(data.title + ( (data.rating.id >= 3) ? ' - ab '+data.altersfreigabe+' Jahren' : (data.rating.id == 2) ? ' - für Kinder geeignet?' : ' - nichts für Kinder!' ));
            this.flimmoMetaService.setDescription(data.paed);
            this.flimmoMetaService.setOG('/besprechung/'+data.id, data.image)
              if (!title) {
                this.router.navigate(['besprechung', data.id, this.flimmoMetaService.prettifyUrl(data.title)], {replaceUrl: true});
              }
            }
          );
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
